import { Component, Injectable, OnInit, forwardRef } from "@angular/core";
import { NavController, NavParams, ModalController, LoadingController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EscalaGrupoPage } from "../escala-grupo/escala-grupo.page";
import { EscalaPessoaPage } from "../../escala-pessoa/escala-pessoa.page";
import { EscalaProvider } from "src/app/services/escala/escala";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Injectable({ providedIn: "root" })
@Component({
  selector: "app-escala",
  templateUrl: "./escala.page.html",
  styleUrls: ["./escala.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NomenclaturaPipe, TranslateModule, LoadingSpinnerComponent],
})
export class EscalaPage implements OnInit {
  idEntidade: any;
  entidade: any;
  permissao: any;
  idEscala: any;
  pagination: any = { currentPage: 0, pageCount: 0 };
  filtro: any = "";
  funcoesList: any = [];
  isEnsino: any = {};
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public escalaProvider: EscalaProvider,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public loadingController: LoadingController
  ) {
    this.idEntidade = this.navParams.get("idEntidade");
    this.entidade = this.navParams.get("entidade");
    this.idEscala = this.navParams.get("idEscala");
    this.permissao = this.navParams.get("permissao");
    this.isEnsino = this.navParams.get("isEnsino");
  }

  ngOnInit() {
    this.loadFuncoes(null);
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  async buscarGrupo(tipo: any) {
    let data = {
      tipo: tipo,
      permissao: this.permissao,
      entidade: this.entidade,
      idEntidade: this.idEntidade,
      idEscala: this.idEscala,
      isEnsino: this.isEnsino,
    };

    const modalPage = await this.modalCtrl.create({
      component: EscalaGrupoPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.loadFuncoes(null);
    }
  }

  async buscarPessoa() {
    let data = {
      entidade: this.entidade,
      idEntidade: this.idEntidade,
      idEscala: this.idEscala,
      isEnsino: this.isEnsino,
    };

    const modalPage = await this.modalCtrl.create({
      component: EscalaPessoaPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.loadFuncoes(null);
    }
  }

  loadFuncoes(infiniteScroll: any) {
    this.pagination.currentPage++;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };
    }

    this.escalaProvider
      .getFuncoesSemPessoa(this.entidade, this.idEntidade, this.pagination, this.filtro)
      .subscribe((res) => {
        if (!infiniteScroll) {
          this.funcoesList = [];
        }

        res.funcoes.forEach((funcao: any) => {
          funcao.qtdDisponivel = funcao.qtd - funcao.qtdDisponivel;
        });

        this.funcoesList = this.funcoesList.concat(res.funcoes);

        this.pagination = res.pagination;

        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  onInput() {
    this.loadFuncoes(null);
  }

  async selecionarFuncao(funcao: { id: string }) {
    const funcaoEscala = {
      entidade: this.entidade,
      idEntidade: this.idEntidade,
      idEscala: this.idEscala,
      idFuncao: funcao.id,
      isEnsino: this.isEnsino,
    };
    this.loaded = false;

    const modalPage = await this.modalCtrl.create({
      component: EscalaPessoaPage,
      componentProps: funcaoEscala,
    });

    modalPage.onWillDismiss().then(async (data) => {
      if (data) {
        this.loadFuncoes(null);
        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      }
    });

    await modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
